import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { getConsent, setConsent, applyGtagConsent } from "@/lib/consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = getConsent();
    if (!stored) setVisible(true);
    else applyGtagConsent(stored);
  }, []);

  if (!visible) return null;

  const choose = (v) => {
    setConsent(v);
    setVisible(false);
  };

  return (
    <div
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-[68px] lg:bottom-0 z-[60] px-3 sm:px-5 pb-3"
    >
      <div className="mx-auto max-w-[1100px] bg-charcoal text-bone rounded-sm shadow-2xl border border-bone/10 p-5 sm:p-6 flex flex-col lg:flex-row lg:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie size={22} className="text-terracotta mt-0.5 shrink-0" />
          <p className="font-sans text-sm leading-relaxed text-bone/85">
            Usiamo cookie tecnici necessari al funzionamento del sito e, previo
            tuo consenso, cookie statistici (Google Analytics) e strumenti di
            terze parti (es. Google Maps). Puoi accettarli tutti o mantenere
            solo quelli necessari. Maggiori info nella{" "}
            <Link to="/cookie" className="text-terracotta underline underline-offset-2">
              Cookie Policy
            </Link>
            .
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 shrink-0">
          <button
            data-testid="cookie-reject"
            onClick={() => choose("necessary")}
            className="px-5 py-2.5 rounded-sm text-sm font-medium border border-bone/30 hover:border-bone text-bone transition-colors duration-300"
          >
            Solo necessari
          </button>
          <button
            data-testid="cookie-accept"
            onClick={() => choose("all")}
            className="px-6 py-2.5 rounded-sm text-sm font-semibold bg-terracotta hover:bg-terracotta-dark text-bone transition-colors duration-300"
          >
            Accetta tutti
          </button>
        </div>
      </div>
    </div>
  );
}
